import { Component, OnDestroy, inject } from '@angular/core';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { ErzeugungsanlageDetailComponent } from '../erzeugungsanlage-detail/erzeugungsanlage-detail.component';
import { ActivatedRoute } from '@angular/router';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'tnb-erzeugungsanlage-page',
    templateUrl: './erzeugungsanlage-page.component.html',
    styleUrls: [
        './erzeugungsanlage-page.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlagePageComponent implements OnDestroy {
    private westnetzSidenavService = inject(WestnetzSidenavService);
    private activateRoute = inject(ActivatedRoute);

    private componentDestroyed = false;

    constructor() {

        this.activateRoute.queryParams
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(params => {
                if (params && (params.erzeugungsanlage || params.createnew === true || params.createnew === 'true')) {
                    this.westnetzSidenavService.openRightnav(ErzeugungsanlageDetailComponent);
                }
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

}

